<template>
  <div id="speed-select">
    <h4 class="mb-4">Choose the XMission Fiber speed for this address</h4>
    <br />
    <label v-for="option of speedOptions.speed_options" :key="option.speed_id" @click="setSpeedDetails(option)">
      <input type="radio" name="speed" class="speed-radio">
      <div :class="['package', option.speed_color]">
        <h4>{{ option.speed_label }} <small>upload and download</small></h4>
        <div class="promo-fmf">{{ option.early_net_connectivity_rate_term }}</div>
        <b class="price">${{ option.monthly_gross_connectivity_rate }}</b>/mo
        <small class="breakdown">{{ option.monthly_gross_connectivity_rate_breakdown }}</small>
        <span v-if="option.speed_id !== 'speed_10000_sym'">
<!--          <div class="promo-2dollars xm-g-bg">$<b>2</b>/mo off when you add <br/><b>XWi Home</b></div>-->
           <div class="promo-2dollars xm-g-bg">$<b>{{ option.monthly_gross_connectivity_router_rate }}</b>/mo when you add <b>XWi Home</b></div>
          <p>{{ option.speed_description }}</p>
        </span>
        <span v-else>
          <p class="mb-0">
            <img src="https://asset.xmission.com/xwi/xwi-router-white.png" width="90" class="float-left mr-2" alt="XWi router white">
              10Gbps comes bundled with <img :src="xwiLogoUrl" alt="XWi" style="height:20px; vertical-align:baseline"> including router &amp; app.
            </p>
        </span>

      </div>
    </label>
    <div style="line-height:normal;" class="mr-3">
      <span v-for="promo_legal_disclaimer of legalDisclaimers">
        <b>{{ promo_legal_disclaimer.label }}</b>:&nbsp;<small>{{ promo_legal_disclaimer.disclaimer }}</small>&nbsp;
      </span>
    </div>
  </div>
</template>


<script>

  import logger from "../../lib/logger";
  import {mapGetters} from "vuex";

  export default {
    data () {
      return {
        form_data: {
          speed_id: '',
          external_soid: ''
        },
      }
    },

    props: {
      // service should be an instance of ConnectivityService
      serviceDetails: {
        required: true,
      }
    },

    computed: {
      speedOptions() {
        if (!this.serviceDetails){
          return [];
        }
        return this.serviceDetails.speed_options;
      },
      legalDisclaimers () {
        return this.speedOptions.promo_legal_disclaimers;
      },
      formValid () {
        return this.form_data.speed_id !== '';
      },
      formData() {
        return this.form_data;
      },
    xwiLogoUrl () {
      if (this.hasDarkTheme) {
        return 'https://asset.xmission.com/xwi/xwi-logo-black.png';
      }
      return 'https://asset.xmission.com/xwi/xwi-logo-white.png';
    },
      ...mapGetters([
        'hasDarkTheme',
      ])
    },
    methods: {
      setSpeedDetails(details) {
        logger.debug('setSpeedDetails', details)
        this.form_data.speed_id = details.speed_id;
        this.form_data.external_soid = details.external_soid;
      }
    },

    watch : {
      formValid(new_val) {
        this.$emit('form-state', new_val);
        this.$emit(new_val ? 'form-valid' : 'form-invalid');
      },
      formData: {
        handler (new_val) {
          if (new_val){
            this.$emit('input', new_val);
          }
        },
        deep: true
      },
    }
  }
</script>


<style scoped>

.xm-y-bg h4 {background-color:#9EB231; border:1px solid #9EB231}
.xm-b-bg h4 {background-color:#0290AE; border:1px solid #0290AE}
.xm-r-bg h4 {background-color:#FF6613; border:1px solid #FF6613}
.xm-g-bg h4 {background-color:#666666; border:1px solid #666666}

#speed-select h4 {
  flex:0 0 100%
}

#speed-select {display:flex; margin-top:20px; flex-wrap:wrap}
#speed-select label {display:flex; flex:1; position:relative; min-width:200px; margin-bottom:12px}
#speed-select .package {flex:1}

.speed-radio {
  margin:0 auto;
  display:block;
  clear:both;
  position:absolute;
  left:10px;
  top:10px
}
.speed-radio:checked+.package {
  border:1px solid black;
  color:#444;
  box-shadow:0 2px 15px rgba(0,0,0,0.2);
  opacity:1.0;
}

.speed-radio:checked+.package h4 {
  border-color:black;
}

.promo-fmf {
  font-weight:bold;
  padding-bottom:6px;
  margin-bottom:6px;
  border-bottom:3px solid #666;
  font-size:20px
}

.package.xm-b-bg .promo-fmf {
  border-bottom-color:#0290AE;
  color:#0290AE;
}

.package.xm-y-bg .promo-fmf {
  border-bottom-color:#9EB231;
  color:#9EB231;
}

.package.xm-r-bg .promo-fmf {
  border-bottom-color:#FF6613;
  color:#FF6613;
}

.package {
  border:1px solid #bbb;
  border-radius:6px;
  padding:8px 12px 20px 12px;
  text-align:center;
  font-weight:normal;
  font-size:16px;
  color:#444;
  line-height:normal;
  margin:0 20px 0 0;
}

.package:hover {
  border-color:#888;
  cursor:pointer;
  box-shadow:1px 1px 2px #ccc;
}

.package:hover h4 {
  text-shadow:2px 2px 2px rgba(0,0,0,0.2);
  border-color:#888;
  transition:all linear 0.1s;
}

.package:hover h4 small {
  text-shadow:none;
  color:rgba(255,255,255,0.8)
}

.package h4 {
  margin:-9px -13px 20px -13px;
  padding:20px 8px;
  font-size:30px;
  color:white;
  border-top-left-radius:6px;
  border-top-right-radius:6px;
  border-bottom:0;
  transition:all linear 0.1s
}

.package h4 small {
  color:white;
  color:rgba(255,255,255,0.6);
  font-size:13px;
  display:block;
  margin-top:2px;
  transition:all linear 0.1s
}

.package p {
  text-align:left;
  padding:16px 12px 0 12px;
  line-height:130%
}

.package small {font-weight:normal; display:block}
.package input {display:none}

b.price {
  font-size:24px;
}

small.breakdown {
  font-size:11px;
  opacity:0.7;
  display:block;
}

.promo-2dollars {color:white; padding:4px 0; margin-top:16px; font-size:13px}
.promo-2dollars b {font-size:16px}

.xm-y-bg .promo-2dollars {background-color:#9EB231;}
.xm-b-bg .promo-2dollars {background-color:#0290AE;}
.xm-r-bg .promo-2dollars {background-color:#FF6613;}
.xm-g-bg .promo-2dollars {background-color:#666666;}


</style>



// WEBPACK FOOTER //
// SpeedSelect.vue?12f390f1